export const ERR_SIZE_NOT_IN_COLOR = 'SIZE_NOT_IN_COLOR';
export const ERR_SIZE_TYPE_INVALID = 'SIZE_TYPE_INVALID';
export const ERR_SIZE_NOT_IN_TYPE = 'SIZE_NOT_IN_TYPE';
export const ERR_SIZE_COLOR_OOS = 'SIZE_COLOR_OOS';
export const ERR_SIZE_OOS = 'SIZE_OOS';
export const ERR_SIZE_FIT_OOS = 'SIZE_FIT_OOS';
export const ERR_SELECT_SIZE = 'SELECT_SIZE';
export const ERR_SIZE_NOT_IN_FIT = 'SIZE_NOT_IN_FIT';
export const ERR_QUANTITY_UNAVAIL = 'QUANTITY_UNAVAIL';
export const ERR_MOVE_TO_WISHLIST = 'MOVE_TO_WISHLIST_ERROR';
export const L10N_CATEGORY_SEO_TITLE = 'category_seo-title';
export const L10N_CATEGORY_SEO_META_DESCRIPTION = 'category_seo-meta-description';
export const L10N_PRODUCT_WISHLIST_SUCCESS = 'product_wishlist-success-message';
export const L10N_PRODUCT_AVAIL_PREORDER = 'product_availability-preorder-message';
export const L10N_PRODUCT_AVAIL_BACKORDER = 'product_availability-backorder-message';
export const L10N_PRODUCT_AVAIL_LOW_STOCK = 'product_availability-low-stock-message';
export const L10N_PRODUCT_AVAIL_OUT_OF_STOCK = 'product_availability-out-of-stock-message';
export const L10N_PRODUCT_AVAIL_DISCONTINUED = 'product_availability-discontinued-message';
export const L10N_PRODUCT_AVAIL_DROPSHIP = 'product_availability-dropship-message';
export const L10N_PRODUCT_AVAIL_MADE_TO_ORDER = 'product_availability-made-to-order-message';
export const L10N_PRODUCT_AVAIL_IN_STOCK_MADE_TO_ORDER = 'product_availability-made-to-order-instock-message';
export const L10N_PRODUCT_AVAIL_ONE_LEFT = 'product_availability-one-left-message';
export const L10N_PRODUCT_AVAIL_TWO_LEFT = 'product_availability-two-left-message';
export const ERR_RAS_MIN = 'request-swatch-minimum-selection-error';
export const ERR_RAS_MAX = 'request-swatch-maximum-selection-error';
